import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CrossReference } from '../../../types/types';

export interface SellerCellRendererComponentParams {
  manufacturerName: string;
  sellerName: string;
}

@Component({
  selector: 'app-crosses-seller-cell-renderer',
  template: `
    <!-- prettier-ignore -->
    <span>
      @if(sellerName) {
        <div class="mb-1 text-truncate custom-line-height-cell" data-test-selector="seller-name">
          {{ sellerName }}
        </div>
      } 
      
      @if(manufacturerName && manufacturerName !== sellerName) {
        <div class="text-muted fw-normal text-truncate custom-line-height-cell" data-test-selector="manufacturer-name">
          {{ manufacturerName }}
        </div>
      }
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SellerCellRendererComponent implements ICellRendererAngularComp {
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  sellerName!: string;
  manufacturerName!: string;

  agInit({ manufacturerName, sellerName }: CustomParams): void {
    this.manufacturerName = manufacturerName;
    this.sellerName = sellerName;
    this.changeDetectorRef.detectChanges();
  }

  refresh(): boolean {
    return false;
  }
}

interface CustomParams
  extends ICellRendererParams<CrossReference, number>,
    SellerCellRendererComponentParams {}
